import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import { AlertService } from '@shared-services/alert.service';
import { AppConfig } from '@shared-configs/app-config';
import { AuthenticationService } from '@auth-services/authentication.service';
import { escapeHtml } from '@shared-helpers/html-escape';

@Component({
  templateUrl: './Message.template.html',
  selector: 'MessageVBT',
  encapsulation: ViewEncapsulation.None,
})

export class MessageComponent implements OnInit {

  _JsonObject = {};
  _title = '';
  public ErrorMessage: string;

  constructor(private _authService: AuthenticationService,
  private _alertService:AlertService) {
    swal.mixin({ heightAuto: false });
  }

  ngOnInit(): void {
    this.ErrorMessage = '';
  }

  public ShowModal(title: string, obj: any) {
    this.ErrorMessage = '';
    if (AppConfig.debug === true) {
      this._title = title;
      this._JsonObject = JSON.parse(obj);
      document.getElementById('ErrorModalButton').click();
    }
  }

  public ExceptionModal(title: string, obj: any, state: boolean = false) {
    this.ErrorMessage = '';
    if (AppConfig.debug === true) {
      this._title = title;

      if (obj.ErrorCode === undefined) {
        this.ErrorMessage = obj.Message;
        this._alertService.showCustomMessage('Hata !', escapeHtml(obj.Message), 'error');
      } else {
        this._JsonObject = obj;
        document.getElementById('ErrorModalButton').click();
      }
    } else {
      console.log(title + '-' + JSON.stringify(obj));
      if (obj.error !== null && obj.error !== undefined) {
        this._alertService.showCustomMessage('Hata', escapeHtml(obj.error.Message), 'error');
      }
      else {
        this._alertService.showCustomMessage(escapeHtml(obj.ErrorCode), escapeHtml(obj.Message), 'error');
      }
    }

    if (state) {
      //      this._authService.logoutNoneService();
    }
  }
}

